import script from "./ServiceDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./ServiceDetailPage.vue?vue&type=style&index=0&id=3066adf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3066adf4"]])

export default __exports__